export default {
  authResult: '',
  token: localStorage.getItem('token') || '',
  user: JSON.parse(localStorage.getItem('user')) || {},
  userPerm: JSON.parse(localStorage.getItem('user'))
    ? Object.keys(JSON.parse(localStorage.getItem('user')).permissions).map((key) => JSON.parse(localStorage.getItem('user')).permissions[key])
    : null
};
